import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { UsuarioAlteraSenhaModalComponent } from '../../../../home/usuario/altera-senha-modal/usuario-altera-senha-modal.component';
import { UsuarioAvatarService } from '../../../../home/usuario/avatar/services/usuario-avatar.service';
import { IAvatarSettings } from '../avatar/avatar.component';

export interface IAccountMenuItem {
  label: string;
  icon: string;
  action?: () => void;
  routerLink?: string;
  visible?: boolean;
}

export interface IAccountUser {
  name: string;
  email: string;
  companyName?: string;
}

@Component({
  selector: 'sgt-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent implements OnInit, OnDestroy {
  @ViewChild('alteraSenhaModal') alteraSenhaModal: UsuarioAlteraSenhaModalComponent;

  user: IAccountUser;
  userPerfil: string;
  isOpen = false;

  private avatarUrl: string | null = null;
  private avatarUrlSub$: Subscription;

  menuItems: IAccountMenuItem[] = [
    {
      label: 'Perfil',
      icon: 'fa-user',
      routerLink: '/configuracoes/usuario-perfil'
    },
    {
      label: 'Configurações',
      icon: 'fa-cogs',
      routerLink: '/configuracoes'
    },
    {
      label: 'Alterar senha',
      icon: 'fa-key',
      action: () => this.openChangePasswordModal()
    }
  ];

  private readonly CONFIGURACOES_LINK = '/configuracoes';

  get avatarSettings(): IAvatarSettings {
    return {
      fullName: this.user?.name,
      imageUrl: this.avatarUrl,
      size: 32
    };
  }

  constructor(
    private elementRef: ElementRef,
    private authService: AuthService,
    private usuarioAvatarService: UsuarioAvatarService
  ) {}

  ngOnInit(): void {
    this.setUsuario();
    this.setMenuItemsVisibility();
  }

  private setMenuItemsVisibility(): void {
    const podeAcessarCentral = this.authService.podeAcessarCentralConfiguracoes();
    this.menuItems = this.menuItems.map((item) =>
      item.routerLink === this.CONFIGURACOES_LINK
        ? { ...item, visible: podeAcessarCentral }
        : item
    );
  }

  private setUsuario(): void {
    const avatarUrl = this.usuarioAvatarService.getUrl();
    this.avatarUrl = avatarUrl === 'null' ? null : avatarUrl;

    this.avatarUrlSub$ = this.usuarioAvatarService
      .getSubject()
      .subscribe((url: string) => {
        this.avatarUrl = url === 'null' ? null : url;
      });

    const usuario = this.authService.getUsuario();
    this.user = {
      name: usuario.nome,
      email: usuario.login,
      companyName: this.authService.getEmpresa()?.nomeFantasia
    };
    this.userPerfil = this.authService.getPerfilUsuario()?.nome;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.close();
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.close();
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  close(): void {
    this.isOpen = false;
  }

  onMenuItemClick(item: IAccountMenuItem): void {
    this.close();
    item.action?.();
  }

  openChangePasswordModal() {
    const idUsuario = this.authService.getIdUsuario();
    this.alteraSenhaModal.open(idUsuario, this.user?.name);
  }

  onLogout(): void {
    this.close();
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.avatarUrlSub$?.unsubscribe();
  }
}
